import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-pow-time-pay-check-ls',
  templateUrl: './pow-time-pay-check-ls.component.html',
  styleUrls: ['./pow-time-pay-check-ls.component.css']
})
export class PowTimePayCheckLsComponent implements OnInit {
    argType;

    argValue;

    public itemsListPayCheckLs: Item[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadPayCheckLs() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListPayCheckLs = await this.datatask.Post(1374, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private loadGrid() {
        if (!!this.argType && !!this.argValue) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('powtimepaycheckls_grid')
                    .setLoadDataFunction({
                        method: 3507,
                        parameters: {
                            argtype: this.argType,
                            argvalue: this.argValue
                        }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        this.loadPayCheckLs();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
